import { useMutation } from '@src/query';


/**
 * Settings → Profile mutation hooks (T10). Each wraps the shared `useMutation`
 * engine with the injected-`queryClient` `mutateFn({ apiClient, queryClient })`
 * contract — the corelib query singleton is NOT imported here. Invalidation runs
 * inside `mutateFn`; the caller passes the `/users/me/` `queryKey` it already
 * holds from `useMeQuery`, so the exact cache key is preserved unchanged.
 *
 * Mirrors `query/garage/useDonorMutations.js`.
 */

/** PATCH the current user's profile (name/email). Variables: `{ payload, queryKey }`. */
function useProfileSaveMutation(params) {
  return useMutation({
    mutateFn: ({ apiClient, queryClient, payload, queryKey }) => apiClient
      .request({ url: '/users/me/', method: 'PATCH', payload })
      .then((data) => {
        queryClient.invalidateQueries({ queryKey });
        return data;
      }),
    ...params,
  });
}


/** PATCH the current user's avatar (upload via multipart, or clear with
 * `{ avatar: null }`). Variables: `{ payload, contentType, queryKey }`. */
function useProfileAvatarMutation(params) {
  return useMutation({
    mutateFn: ({ apiClient, queryClient, payload, contentType, queryKey }) => apiClient
      .request({ url: '/users/me/', method: 'PATCH', payload, contentType })
      .then((data) => {
        queryClient.invalidateQueries({ queryKey });
        return data;
      }),
    ...params,
  });
}


/** Change password (djoser set_password). Variables: `{ payload }`. No cache
 * invalidation — the password is not part of any query. */
function usePasswordChangeMutation(params) {
  return useMutation({
    mutateFn: ({ apiClient, payload }) => apiClient.request({
      url: '/users/set_password/',
      method: 'POST',
      payload,
    }),
    ...params,
  });
}


export {
  usePasswordChangeMutation,
  useProfileAvatarMutation,
  useProfileSaveMutation,
};
